import { observer } from "mobx-react"
import * as React from "react"
import Select from "BookingSystem/components/Select"
import { Member } from "BookingSystem/db/Member"
const dayjs = require("dayjs")

interface Props {
  member: Member | null
  style?: Object
}

@observer
class DaysDropdown extends React.Component<Props> {
  render() {
    const { member, style } = this.props
    var daysOfTheMonth = []
    var daysInMonth =
      member && member.object.dobYear && member.object.dobMonth
        ? dayjs(
            `${member.object.dobYear}-${member.object.dobMonth}-01`
          ).daysInMonth()
        : 31
    for (var i = 1; i <= daysInMonth; i++) {
      daysOfTheMonth.push(i)
    }

    return (
      <Select
        value={
          member && member.object.dobDay && member.object.dobDay.length > 0
            ? member.object.dobDay
            : "Day"
        }
        onChange={(event: any) => {
          if (member) member.object.dobDay = event.target.value
        }}
        style={style}
      >
        <option value="Day">Day</option>
        {daysOfTheMonth.map((d, i) => (
          <option key={i} value={d}>
            {d}
          </option>
        ))}
      </Select>
    )
  }
}

export default DaysDropdown
